import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import Text from "@streeteasy/design-system/deprecated/Text";
import TextLink from "@streeteasy/design-system/deprecated/TextLink";

import { largeScreen } from "src/shared/constants/screenSizes";

const BuildingLink = styled(TextLink).attrs({ theme: "whaleGrey" })`
  font-size: 18px;
  line-height: 1.3;
  margin: 0;
`;

const Dot = styled.div`
  &::after {
    background: ${colors.foxGrey};
    border-radius: 50%;
    content: "";
    display: inline-block;
    height: 4px;
    margin: 0 5px;
    vertical-align: middle;
    width: 4px;
  }

  @media (min-width: ${largeScreen}px) {
    &::after {
      background: ${colors.koalaGrey};
      margin: 0 10px;
    }
  }
`;

const ListingInformation = styled.div`
  display: flex;
  justify-content: center;
  margin: 5px 0;
`;

const MediumListingText = styled(Text).attrs({ type: "default" })`
  font-size: 18px;
  line-height: 1.3;
`;

const RoomInformation = styled.div`
  align-items: flex-end;
  display: flex;
  justify-content: center;
  margin: 0 10px;
`;

const SmallListingText = styled(Text).attrs({ type: "sm" })`
  color: ${colors.koalaGrey};
  padding: 0 5px;
  font-weight: ${({ bold }) => (bold ? "bold" : "normal")};
  border-right: ${({ border }) =>
    border ? `1px solid ${colors.rabbitGrey}` : 0};

  @media (min-width: ${largeScreen}px) {
    color: ${colors.whaleGrey};
    padding: 0 10px;
  }
`;

const StickyButtonSection = styled.div`
  display: flex;
  width: auto;

  @media (min-width: ${largeScreen}px) {
    width: 356px;
  }
`;

const StickyDesktopContainer = styled.div`
  align-items: center;
  border-bottom: 1px solid ${colors.rabbitGrey};
  display: flex;
  flex-flow: row wrap;
  height: 50px;
  justify-content: space-between;
  margin: 0 auto;
  max-width: ${largeScreen}px;
`;

const StickyMobileContainer = styled.div`
  border-top: solid 1px ${colors.rabbitGrey};
  display: flex;
  flex-flow: column wrap;
  padding: 5px 10px;
`;

BuildingLink.displayName = "BuildingLink";
Dot.displayName = "Dot";
ListingInformation.displayName = "ListingInformation";
MediumListingText.displayName = "MediumListingText";
RoomInformation.displayName = "RoomInformation";
SmallListingText.displayName = "SmallListingText";
StickyButtonSection.displayName = "StickyButtonSection";
StickyDesktopContainer.displayName = "StickyDesktopContainer";
StickyMobileContainer.displayName = "StickyMobileContainer";

export {
  BuildingLink,
  Dot,
  ListingInformation,
  MediumListingText,
  RoomInformation,
  SmallListingText,
  StickyButtonSection,
  StickyDesktopContainer,
  StickyMobileContainer
};
